import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import channels from './modules/channels'
import favoriteChannels from './modules/favorite-channels'
import epg from './modules/epg'
import messages from './modules/messages'
import error from './modules/error'
import toast from './modules/toast'
import videoAspectRatio from './modules/video-aspect-ratio'
import debug from './modules/debug'
import videoOptions from './modules/video-options'
import tab from './modules/tab'
import video from './modules/video'

Vue.use(Vuex);

const debugEnv = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    strict: debugEnv,
    modules: {
        login, // done
        channels, // done
        favoriteChannels, // done
        epg, // done?
        messages, // done
        error, // done
        toast,
        videoAspectRatio,
        debug,
        videoOptions,
        tab,
        video
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js